import { Box, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import React from 'react'
import { Link } from 'react-router-dom'

const StyledLink = styled('a')(({ theme }) => ({
   textDecoration: 'none',
   color: 'black',
   fontWeight: 'bold',
   '&:hover': {
      cursor: 'pointer',
      color: theme.palette.primary.dark,
   },
}))

const StyledReactLink = styled(Link)(({ theme }) => ({
   textDecoration: 'none',
   color: 'black',
   fontWeight: 'bold',
   '&:hover': {
      cursor: 'pointer',
      color: theme.palette.primary.dark,
   },
}))
export default function TermsOfUse() {
   return (
      <Box
         sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            textAlign: 'justify',
            px: { lg: '24px', md: '24px', xs: '12px' },
         }}
      >
         <Typography textAlign="center" variant="h3" color="primary.dark">
            Regulamin Serwisu
         </Typography>
         <Typography>
            Niniejszy Regulamin określa ogólne warunki korzystania z Usług dostarczanych za pośrednictwem Serwisu
            Motorro.
         </Typography>
         <Typography>Definicje:</Typography>
         <ol>
            <li>
               <b>Hurtownia</b> - partner Motorro prowadzący sprzedaż Produktów, z którym Klient pozostaje w stosunkach
               gospodarczych na podstawie odrębnie zawartej umowy.
            </li>
            <li>
               <b>Klient</b> - podmiot korzystający z Serwisu w ramach Konta Klienta, będący franczyzobiorcą (mający
               podpisaną ważną umowę franczyzową ) Euromaster któremu Serwis został udostępniony przez Euromaster.
            </li>
            <li>
               <b>Konto Klienta</b> - dostęp do Serwisu dla Klienta po dokonaniu Rejestracji lub po zakupie Planu.
            </li>
            <li>
               <b>Licencja </b> - uprawnienie do korzystania z Serwisu po założeniu Konta Klienta oraz dokonania zakupu
               odpowiedniego Planu.
            </li>
            <li>
               <b>Operator Serwisu </b> - Euromaster Polska Spółka z ograniczoną odpowiedzialnością z siedzibą w
               Olsztynie (adres: ul. Leonharda 9, 10-454 Olsztyn) NIP 739-366-91-22, zarejestrowana w rejestrze
               przedsiębiorców KRS prowadzonym przez Sąd Rejonowy w Olsztynie pod numerem KRS 298900 działając za
               pośrednictwem Motorro sp. z o.o. z siedzibą w Lublinie, Al. Warszawska 96A lok.7, 20-824 Lublin, wpisana
               do Rejestru Przedsiębiorców prowadzonego przez Sąd Rejonowy Lublin-Wschód w Lublinie z siedzibą w
               Świdniku, VI Wydział Gospodarczy Krajowego Rejestru Sądowego pod nr KRS: 0000632323, NIP: 7123317347,
               REGON: 36516187 (“Motorro”).
            </li>
            <li>
               <b>Polityka Prywatności </b> - polityka prywatności i plików cookies zawierająca postanowienia dotyczące
               przetwarzania danych osobowych przez Operatora Serwisu.
            </li>
            <li>
               <b>Pracownik </b> - pracownik lub współpracownik (tj. osoba wykonująca usługi na rzecz Klienta na
               podstawie umowy cywilnoprawnej) Klienta.
            </li>
            <li>
               <b>Produkty </b> - produkty oferowane do sprzedaży przez Hurtownie, które wyświetlane są w ramach Konta
               Klienta, lub produkty oferowane przy wykorzystaniu narzędzia Baselinker.
            </li>
            <li>
               <b>Regulamin </b> -niniejszy regulamin Serwisu. Dokument ten stanowi jednocześnie regulamin świadczenia
               usług drogą elektroniczną, o którym mowa w art. 8 ust. 1 pkt 1 ustawy o świadczeniu usług drogą
               elektroniczną z 18 lipca 2002 r.
            </li>
            <li>
               <b>Rejestracja </b> - proces utworzenia Konta Klienta, na który składa się podanie danych wymaganych
               przez Serwis, akceptacja Regulaminu i Polityki Prywatności, oraz aktywacja Konta Klienta.
            </li>
            <li>
               <b>Serwis </b> -prowadzony przez Operatora Serwisu internetowy serwis dostępny w domenie:
               http://smr.euromaster.pl/.
            </li>
            <li>
               <b>Subkonto </b> -konto Pracownika powiązane z Kontem Klienta, zakładane przez Klienta dla swojego
               Pracownika. Nie stanowi odrębnej umowy o świadczenie usługi prowadzenia Konta.
            </li>
            <li>
               <b>Subużytkownik </b> - osoba, na rzecz której utworzone zostało Subkonto.
            </li>
            <li>
               <b>Umowa Konta Klienta </b> - zawarta na odległość umowa o świadczenie usługi prowadzenia Konta zawierana
               między Operatorem Serwisu a Klientem za pośrednictwem Serwisu w momencie akceptacji przez Klienta
               Regulaminu i rejestracji Konta Klienta. Umowa jest zawierana na czas nieokreślony.
            </li>
            <li>
               <b>Usługi </b> - usługi świadczone lub udostępniane przez Operatora Serwisu z wykorzystaniem Serwisu.
            </li>
            <li>
               <b>Weryfikacja </b> - proces sprawdzający Klienta zakładającego Konto Klienta w Serwisie przeprowadzany
               przez Operatora Serwisu polegający na weryfikacji podanych podczas Rejestracji danych, weryfikacji numeru
               NIP, jak również poprzez potwierdzenie linku aktywacyjnego wysłanego na adres e-mail podany w trakcie
               Rejestracji przez Klienta.
            </li>
         </ol>
         <Typography variant="h6" textAlign="center" fontWeight="bold">
            1.Postanowienia wstępne
         </Typography>
         <Typography>
            1.1. Niniejszy Regulamin określa zasady korzystania z Serwisu przez Klienta. Każdy Klient obowiązany jest
            zapoznać się z treścią Regulaminu i zaakceptować jego postanowienia przed rozpoczęciem korzystania z
            Serwisu.
         </Typography>
         <Typography>
            1.2. W ramach Serwisu Operator Serwisu umożliwia korzystanie z funkcjonalności Serwisu. Głównymi
            funkcjonalnościami Serwisu są dostęp do informacji na temat ofert i cen Produktów Hurtowni, z którymi Klient
            pozostaje w stosunkach gospodarczych lub z którymi może nawiązać stosunki gospodarcze, możliwość
            porównywania ofert Produktów oraz możliwość zgłoszenia chęci zamówienia Produktu z Hurtowni z wykorzystaniem
            Serwisu.
         </Typography>
         <Typography>
            1.3. Korzystając z Serwisu, Klient wyraża zgodę na związanie się warunkami niniejszego Regulaminu. Jeśli
            Klient nie zgadza się z postanowieniami niniejszego Regulaminu, korzystanie z funkcjonalności Serwisu jest
            niedozwolone.
         </Typography>
         <Typography>
            1.4. Zasady wynagrodzenie za korzystanie z Konta uzgodnione będą indywidualnie pomiędzy Klientem a
            Operatorem w formie dokumentowej.
         </Typography>
         <Typography>
            1.5. Ilekroć w treści Regulaminu lub Serwisu jest mowa o czynnościach podejmowanych przez Klienta, są to
            czynności które w imieniu Klienta powinny podjąć osoby uprawnione do jego reprezentacji. Dokonanie czynności
            w imieniu Klienta jest równoznaczne z oświadczeniem tej osoby o posiadaniu przez nią prawa do reprezentacji
            Klienta.
         </Typography>
         <Typography>
            1.6 O ile nie zastrzeżono inaczej, ilekroć mowa jest o adresie e-mail Operatora Serwisu, jest to adres
            e-mail: kontakt@motorro.pl
         </Typography>
         <Typography variant="h6" textAlign="center" fontWeight="bold">
            2.Konto klienta
         </Typography>
         <Typography>
            2.1. Klient może korzystać z funkcjonalności Konta Klienta wyłącznie po dokonaniu Rejestracji na zasadach
            określonych w niniejszym Regulaminie i założeniu Konta Klienta.
         </Typography>
         <Typography>2.3. Rejestracja Konta Klienta wymaga:</Typography>
         <Typography sx={{ ml: '24px' }}>
            2.3.1. Wypełnienia formularza dostępnego w Serwisie i podania wymaganych danych oraz hasła ustanowionego
            zgodnie z zasadami podanymi w formularzu;
         </Typography>
         <Typography sx={{ ml: '24px' }}>
            2.3.2. Zapoznania się z Polityką Prywatności i Regulaminem oraz akceptacji ich postanowień;
         </Typography>
         <Typography>
            2.4. Po spełnieniu obowiązków, o których mowa w pkt 2.5, na podany przez Klienta adres e-mail zostanie
            wysłane potwierdzenie utworzenia Konta Klienta oraz link do jego aktywacji. Rejestracja zostanie zakończona
            w momencie aktywacji Konta przez Klienta. W tym momencie dochodzi do zawarcia umowy o świadczenie usługi
            prowadzenia Konta.
         </Typography>
         <Typography>
            2.5. W ramach funkcjonowania Konta Klienta możliwe jest także założenie Subkont związanych z danym Kontem.
            Klient ma możliwość założenia Subkont dla swoich Pracowników.
         </Typography>
         <Typography>
            2.6. Założenie Subkont, o których mowa powyżej może nastąpić w sposób manualny poprzez dokonanie na Koncie
            Klienta w Serwisie odpowiednich czynności przez Klienta. Pracownik jest informowany o objęciu go Kontem i
            przyznaniu Subkonta, a także poproszony o udzielenie niezbędnych zgód, jeśli ma to zastosowanie.
         </Typography>
         <Typography>
            2.7. Po dokonaniu czynności i wypełnieniu obowiązków, o których mowa w pkt. 2.9. Pracownicy staną się
            Subużytkownikami i będą mogli korzystać z funkcjonalności Serwisu w zakresie objętym Planem Klienta{' '}
         </Typography>
         <Typography>
            2.8. Czas funkcjonowania Subkonta nie może wykraczać poza zakres trwania umowy świadczenia usługi
            prowadzenia Konta Klienta.
         </Typography>
         <Typography>
            2.9. W razie wątpliwości podkreśla się, że Subkonto nie jest oddzielnym Kontem. Założenie Subkonta nie
            stanowi zawarcia osobnej umowy o świadczenie usługi prowadzenia Konta.
         </Typography>
         <Typography>2.10. Klient jest odpowiedzialny za działania Subużytkownika jak za własne.</Typography>
         <Typography>
            2.11. Klient może posiadać tylko jedno Konto Klienta w Serwisie. Zasada ta nie ma zastosowania, jeżeli
            zaistnieje konieczność założenia kolejnego Konta Klienta z powodu braku możliwości dostępu do Konta Klienta
            lub innych ważnych przyczyn wskazanych przez Klienta, przy czym wszelkie wyłączenia w tym zakresie będą
            szczegółowo weryfikowane przez Operatora Serwisu, który będzie uprawniony do zawieszenia Konta Klienta na
            czas weryfikacji lub usunięcia Kont Klienta w przypadku braku potwierdzenia okoliczności uzasadniających
            zastosowanie powyższego wyłączenia.
         </Typography>
         <Typography>
            2.12. Klient zobowiązany jest do podania prawdziwych, poprawnych i aktualnych danych podczas procesu
            Rejestracji oraz korzystania z Serwisu. Klient zobowiązany jest do aktualizacji danych w przypadku ich
            zmiany.
         </Typography>
         <Typography>
            2.13. Klient zobowiązuje się do zachowania w tajemnicy danych dostępowych do Konta Klienta oraz do ich
            ochrony przed dostępem nieuprawnionych osób trzecich. Klient zobowiązany jest niezwłocznie poinformować
            Operatora Serwisu w przypadku powzięcia informacji o uzyskaniu przez nieuprawnione osoby trzecie danych
            dostępowych do Konta Klienta i w miarę możliwości niezwłocznie je zmienić.
         </Typography>
         <Typography>
            2.14. W celu zapewnienia prawidłowego funkcjonowania Usług Serwisu oraz ochrony i zapewnienia bezpieczeństwa
            osób i podmiotów z niego korzystających, Operator Serwisu zastrzega sobie prawo do przeprowadzenia
            dodatkowej weryfikacji aktualności i prawdziwości danych podanych przez Klienta oraz do żądania od Klienta
            potwierdzenia tożsamości reprezentującej go osoby lub innych niezbędnych danych w sposób wybrany przez
            Operatora Serwisu. W przypadku bezskutecznej weryfikacji danych lub tożsamości Klienta, Operator Serwisu
            może zawiesić lub zablokować działanie Konta Klienta.
         </Typography>
         <Typography variant="h6" fontWeight="bold" textAlign="center">
            3. Usługi
         </Typography>
         <Typography>
            3.1. W ramach Konta Klienta Klient uzyskuje dostęp do aplikacji, która pozwala mu na korzystanie z
            następującego rodzaju Usług:
         </Typography>
         <Typography sx={{ ml: '24px' }}>3.1.1. Znajdowanie części samochodowych;</Typography>
         <Typography sx={{ ml: '24px' }}>3.1.2. Weryfikowanie stanów magazynowych Hurtowni;</Typography>
         <Typography sx={{ ml: '24px' }}>
            3.1.3. Weryfikowanie cen części samochodowych w poszczególnych Hurtowniach w czasie rzeczywistym;{' '}
         </Typography>
         <Typography sx={{ ml: '24px' }}>3.1.4. Dokonywanie wyceny części i jej zapisywanie; </Typography>
         <Typography sx={{ ml: '24px' }}>3.1.5. Nawiązywanie współpracy z dostawcami; </Typography>
         <Typography sx={{ ml: '24px' }}>
            3.1.6. Dokonywanie zamówień z poziomu aplikacji, tak jak z katalogu Hurtowni;{' '}
         </Typography>
         <Typography sx={{ ml: '24px' }}>3.1.7. Wdrożenie i szkolenie z korzystania z aplikacji; </Typography>
         <Typography sx={{ ml: '24px' }}>3.1.8. Przeglądanie historii dokonanych zamówień; </Typography>
         <Typography sx={{ ml: '24px' }}>
            3.1.9. Pomoc techniczna w wypadku problemów technicznych w korzystaniu z aplikacji.{' '}
         </Typography>
         <Typography>
            3.2. Klient jest świadomy, że w celu prawidłowego działania funkcjonalności Serwisu, oraz realizacji Usług
            może być wymagane podjęcie odpowiednich działań przez Klienta.
         </Typography>
         <Typography>
            3.3. Serwis nie stanowi sklepu internetowego, lecz serwis porównujący ceny Produktów w Hurtowniach w oparciu
            o dane udostępniane przez Hurtownie.
         </Typography>
         <Typography>
            3.4. Operator Serwisu nie jest stroną umów zawieranych pomiędzy Użytkownikiem a Hurtownią, o których mowa w
            punkcie 3.1.6. Po złożeniu przez Klienta zamówienia Klient otrzymuje potwierdzenie dostępności Produktu od
            Hurtowni oraz potwierdzenie złożenia zamówienia, które jest widoczne w aplikacji. Za wystawienie faktury za
            dokonane zamówienie na rzecz Klienta odpowiedzialna jest właściwa Hurtownia.
         </Typography>
         <Typography>
            3.5. Operator Serwisu nie realizuje dostawy Produktu zamówionego w sposób, o którym mowa w punkcie 3.1.6.
            Czas dostawy zależy wyłącznie od zasad indywidualnie ustalanych w danej Hurtowni.
         </Typography>
         <Typography>
            3.6. Klient ma świadomość, iż niektóre Hurtownie wymagają uprzedniego nawiązania współpracy z Klientem zanim
            będzie on mógł zobaczyć ofertę danej Hurtowni w Serwisie.
         </Typography>
         <Typography variant="h6" fontWeight="bold" textAlign="center">
            4. Cena i Płatności
         </Typography>
         <Typography>
            4.1. Zasady wynagrodzenia za korzystanie z Konta uzgodnione będą indywidualnie pomiędzy Klientem a
            Operatorem w formie dokumentowej.
         </Typography>
         <Typography variant="h6" fontWeight="bold" textAlign="center">
            5. Czas trwania Umowy Konta Klienta i Rozwiązanie Umowy Konta Klienta,
         </Typography>
         <Typography>
            5.1. <b>Czas trwania Umowy Konta Klienta i Rozwiązanie Umowy Konta Klienta, </b>
         </Typography>
         <Typography>
            5.2. Klient jest uprawniony do rozwiązania Umowy Konta w każdym czasie. Rozwiązanie Umowy Konta Klienta
            staje się skuteczne z końcem kolejnego miesiąca. Klient informuje Operatora Serwisu o rozwiązaniu Konta za
            pośrednictwem poczty elektronicznej. Operator Serwisu zastrzega sobie możliwość weryfikacji tożsamości i
            ewentualnego umocowania osoby reprezentującej Klienta.
         </Typography>
         <Typography>
            5.3. Operator Serwisu jest uprawniony do rozwiązania z Klientem Umowy Konta w każdym czasie. O rozwiązaniu
            Umowy Konta Operator Serwisu poinformuje Klienta za pośrednictwem poczty elektronicznej na adres przypisany
            do Konta. Rozwiązanie Umowy Konta przez Operatora Serwisu staje się skuteczne z końcem bieżącego Okresu
            Rozliczeniowego.
         </Typography>
         <Typography>
            5.4. Z chwilą rozwiązania Umowy Konta, Klient traci dostęp do informacji i funkcjonalności związanych z
            dostępem do Konta.
         </Typography>
         <Typography>
            5.5. W razie gdyby dostęp do serwisu był odpłatny Klient jest uprawniony do zrezygnowania z zakupionego
            dostępu do serwisu w terminie 14 dni od daty aktywacji dostępu . W tym celu Klient wysyła informację o
            rezygnacji drogą poczty elektronicznej na adres e-mail:{' '}
            <StyledLink href="mailto:kontakt@motorro.pl" target="_blank">
               kontakt@motorro.pl
            </StyledLink>
         </Typography>
         <Typography>
            5.6. Po upływie okresu, o którym mowa w punkcie 5.5., wypowiedzenie przez Klienta staje się skuteczne z
            końcem następnego miesiąca
         </Typography>
         <Typography variant="h6" fontWeight="bold" textAlign="center">
            6. Wymagania techniczne.
         </Typography>
         <Typography>6.1. Korzystanie z Serwisu odbywa się za pośrednictwem publicznej Sieci Internet.</Typography>
         <Typography>
            6.2. Minimalne wymagania techniczne umożliwiające korzystanie z Serwisu i administrowanie Konta Klienta:
         </Typography>
         <Typography sx={{ ml: '24px' }}>
            6.2.1. urządzenie z aktualnym systemem operacyjnym posiadające dostęp do sieci Internet, o której mowa w pkt
            6.1.
         </Typography>
         <Typography sx={{ ml: '24px' }}>
            6.2.2. zainstalowana oraz prawidłowo skonfigurowana i aktualna wersja przeglądarki internetowej;
         </Typography>
         <Typography sx={{ ml: '24px' }}>6.2.3. aktywne konto poczty elektronicznej.</Typography>
         <Typography sx={{ ml: '24px' }}>
            6.2.4. telefon komórkowy na który wysyłane będą kody w ramach dwuetapowej weryfikacji przy logowaniu do
            konta.
         </Typography>
         <Typography variant="h6" fontWeight="bold" textAlign="center">
            7. Własność intelektualna.
         </Typography>
         <Typography>
            7.1. Operator Serwisu udziela Klientowi niewyłącznej licencji do korzystania z treści zamieszczonych w
            aplikacji w związku z konkretnym wykorzystaniem Serwisu dla wewnętrznych potrzeb Klienta związanych z
            korzystaniem z Serwisu wyłącznie poprzez prawo eksploatacji w całości lub we fragmentach, wprowadzanie,
            wyświetlanie, przechowywanie na stronie internetowej Serwisu oraz wprowadzanie do pamięci komputera.
         </Typography>
         <Typography>7.2. Z zastrzeżeniem punktu 7.1., Klientowi nie przysługuje prawo do:</Typography>
         <Typography sx={{ ml: '24px' }}>
            7.2.1. przechowywania, powielania, rozpowszechniania, modyfikowania, wyświetlania, odtwarzania, tworzenia
            utworów zależnych, oferowania do sprzedaży i wykorzystywania treści oraz informacji zawartych w Serwisie w
            ramach Konta Klienta lub otrzymanych za jego pośrednictwem;
         </Typography>
         <Typography sx={{ ml: '24px' }}>
            7.2.2. omijania, usuwania, wprowadzania zmian, dezaktywacji, niszczenia, blokowania, uniemożliwiania
            funkcjonowania zabezpieczeń treści oraz innych elementów Serwisu w ramach Konta Klienta, w tym graficznego
            interfejsu użytkownika, informacji o prawach autorskich lub logo Serwisu ;
         </Typography>
         <Typography sx={{ ml: '24px' }}>
            7.2.3. dekompilacji, stosowania inżynierii wstecznej i demontażu oprogramowania ani innych produktów i
            procesów dostępnych za pośrednictwem Serwisu;
         </Typography>
         <Typography sx={{ ml: '24px' }}>
            7.2.4. wprowadzania jakichkolwiek kodów lub produktów oraz manipulowania zawartością Serwisu w ramach Konta
            Klienta w jakikolwiek sposób;
         </Typography>
         <Typography sx={{ ml: '24px' }}>
            7.2.5. korzystania z jakiejkolwiek metody wyodrębniania, gromadzenia lub wydobywania danych w celu uzyskania
            dostępu do zawartości Konta Klienta;
         </Typography>
         <Typography sx={{ ml: '24px' }}>7.2.6. sublicencjonowania dostępu do zawartości Konta Klienta</Typography>
         <Typography sx={{ ml: '24px' }}>
            7.2.7. udzielania podmiotom trzecim dostępu do Konta Klienta w Serwisie;
         </Typography>
         <Typography sx={{ ml: '24px' }}>
            7.2.8. przesyłania, wyświetlania, udzielania podmiotom trzecim w jakikolwiek sposób dostępu do zawartości
            Konta Klienta w Serwisie
         </Typography>
         <Typography>
            7.3. Serwis jako wyłączna własność Operatora Serwisu objęty jest ochroną praw autorskich. Chroni ona
            zawartość Serwisu, narzędzia składające się na jego funkcjonalności oraz inne utwory kwalifikowane przez
            prawo autorskie jako dzieła chronione. Wszelkie prawa należą do Operatora Serwisu lub Operator Serwisu
            posiada prawo do korzystania z nich na podstawie odrębnej umowy.
         </Typography>
         <Typography>
            7.4. Zabronione jest jakiekolwiek przetwarzanie danych i innych informacji dostępnych w Serwisie w celu
            udostępnienia ich osobom trzecim w ramach innych serwisów internetowych, jak również poza siecią Internet.
         </Typography>
         <Typography>
            7.5. Operator Serwisu zastrzega, że jakiekolwiek wykorzystywanie, modyfikowanie lub dalsze publikowanie
            zmodyfikowanego utworu będącego własnością Operatora Serwisu jest zabronione.
         </Typography>
         <Typography>
            7.6. Publikacja jakichkolwiek danych zaczerpniętych z Serwisu powinna zawierać dokładne wskazanie Serwisu.
            Operator Serwisu zaznacza, że niezależnie od spełnienia warunku określonego w zdaniu poprzednim, zabronione
            jest publikowanie w celach komercyjnych treści będących własnością Operatora Serwisu na podstawie prawa
            autorskiego bez uprzedniej pisemnej zgody Operatora Serwisu.
         </Typography>
         <Typography variant="h6" fontWeight="bold" textAlign="center">
            8. Ochrona danych osobowych
         </Typography>
         <Typography>
            8.1. Operator Serwisu działa zgodnie z obowiązującymi przepisami o ochronie danych osobowych. Szczegółowe
            informacje, zakres, zasady i warunki prywatności dostępne są na stronie:{' '}
            <StyledReactLink to="/privacy-policy">https://smr.euromaster.pl/privacy-policy</StyledReactLink>
         </Typography>
         <Typography>
            8.2. Dane osobowe Klienta mogą być przekazywane podmiotom przetwarzającym dane na zlecenie Operatora Serwisu
            m.in. agencjom zewnętrznym, przy czym takie podmioty przetwarzają dane na podstawie umowy z Administratorem
            i wyłącznie zgodnie z poleceniami Administratora a przetwarzanie danych osobowych będzie uwzględniało
            konieczne środki bezpieczeństwa.
         </Typography>
         <Typography variant="h6" fontWeight="bold" textAlign="center">
            9. Niedopuszczalne działania Klienta
         </Typography>
         <Typography>
            9.1. Klient jest uprawniony do korzystania z Serwisu zgodnie z jego przeznaczeniem, w granicach prawa i
            przyzwoitości publicznej oraz z poszanowaniem praw i własności innych osób. W szczególności Klient
            zobowiązuje się:
         </Typography>
         <Typography sx={{ ml: '24px' }}>
            9.1.1. nie podejmować działań, które mogłyby zakłócić prawidłowe funkcjonowanie Serwisu, w tym nie ingerować
            w zawartość Serwisu oraz Kont ani w elementy informatyczne Platformy;
         </Typography>
         <Typography sx={{ ml: '24px' }}>
            9.1.2. nie podejmować działań nieetycznych lub niezgodnych z prawem;
         </Typography>
         <Typography sx={{ ml: '24px' }}>
            9.1.3. powstrzymać się od: działania w złej wierze, nadużywania funkcjonalności Serwisu, wykorzystywania
            Serwisu i Usług świadczonych za jego pośrednictwem niezgodnie z jego przeznaczeniem i niezgodnie z
            Regulaminem;
         </Typography>
         <Typography>
            9.2. Klient zobowiązany jest do przestrzegania obowiązków określonych w rozdziale 9 Regulaminu na każdym
            etapie korzystania z Serwisu, w odniesieniu do każdej oferowanej funkcjonalności.
         </Typography>
         <Typography>
            9.3.Zabrania się agregowania i przetwarzania danych oraz innych informacji dostępnych w Serwisie w celu ich
            dalszego wykorzystywania w ramach jakichkolwiek działań poza określonymi w Regulaminie, a także ich dalszego
            udostępniania w ramach innych serwisów internetowych.
         </Typography>
         <Typography>
            9.4. Operator Serwisu jest uprawniony do zablokowania Konta, jeżeli zachodzi podejrzenie, że za
            pośrednictwem Konta mogły lub mogą być podejmowane działania zagrażające bezpieczeństwu Klientów w Serwisie,
            jak również w przypadku, gdy działania podejmowane za pośrednictwem Konta negatywnie wpływają na dobre imię
            Operatora Serwisu lub w inny sposób szkodzą Operatorowi Serwisu.
         </Typography>
         <Typography>
            9.5. W przypadku poważnego naruszenia prawa z wykorzystaniem Serwisu, jak również poważnego lub
            powtarzającego się naruszenia Regulaminu, Operator Serwisu może, z zachowaniem zasad proporcjonalności i
            poszanowania swobody obrotu, zawiesić Konto Klienta lub czasowo lub trwale je zablokować, co będzie
            równoznaczne z czasowym zawieszeniem świadczenia usług na rzecz Klienta, z zastrzeżeniem poniższych zasad:
         </Typography>
         <Typography sx={{ ml: '24px' }}>
            9.5.1. zawieszenie Konta Klienta oznacza czasowe zawieszenie jego funkcjonalności. Klient, którego Konto
            zostało zawieszone, traci możliwość aktywnego korzystania z Serwisu.
         </Typography>
         <Typography sx={{ ml: '24px' }}>
            9.5.2. zablokowanie Konta Klienta oznacza, że Klient traci możliwość logowania się na Konto.
         </Typography>
         <Typography variant="h6" fontWeight="bold" textAlign="center">
            10. Odpowiedzialność Operatora Serwisu
         </Typography>
         <Typography>
            10.1. Operator Serwisu podejmuje uzasadnione starania, aby zapewnić aktualność, dokładność i nieprzerwaną
            dostępność zawartości i funkcjonalności Serwisu.
         </Typography>
         <Typography>
            10.2.Operator Serwisu nie ponosi odpowiedzialności za poprawność działania operatorów zapewniających
            łączność z Serwisem zarówno po stronie Operatora Serwisu, jak i osób korzystających z Platformy.
         </Typography>
         <Typography>
            10.3. W związku z tym, że Operator Serwisu nie jest stroną umów zawieranych pomiędzy Klientem a Hurtownią,
            Operator Serwisu nie ponosi odpowiedzialności za:
         </Typography>
         <Typography sx={{ ml: '24px' }}>
            10.3.1. realizację dostawy Produktu w związku z zamówieniem złożonym w Hurtowni przez Klienta;
         </Typography>
         <Typography sx={{ ml: '24px' }}>
            10.3.2. roszczenia z tytułu rękojmi, gwarancji oraz innych uprawnień związanych z Produktem i transakcją
            sprzedaży,
         </Typography>
         <Typography sx={{ ml: '24px' }}>
            10.3.3. niewykonanie lub nienależyte wykonanie zobowiązania przez Hurtownię bądź Klienta w związku z umową
            zawartą pomiędzy Klientem a Hurtownią,
         </Typography>
         <Typography sx={{ ml: '24px' }}>
            10.3.4. jakość, bezpieczeństwo, legalność Produktów oferowanych przez Hurtownie,
         </Typography>
         <Typography sx={{ ml: '24px' }}>
            10.3.5. prawidłowy dobór numeru Produktu (numeru części) przez Klienta.
         </Typography>
         <Typography variant="h6" fontWeight="bold" textAlign="center">
            11. Zapytania i reklamacje
         </Typography>
         <Typography>
            11.1.Zapytania, wnioski, reklamacje oraz uwagi Klienta dotyczące funkcjonowania Serwisu, lub Usług
            świadczonych za jego pośrednictwem należy kierować na dedykowany adres e-mail Operatora Serwisu:
            <StyledLink href="mailto:kontakt@motorro.pl" target="_blank">
               kontakt@motorro.pl
            </StyledLink>{' '}
            Reklamacja powinna zawierać co najmniej adres e-mail przypisany do Konta Klienta oraz dokładny opis
            okoliczności i nieprawidłowości będących przyczyną reklamacji. Jeżeli podane w reklamacji dane lub
            informacje nie pozwolą Operatorowi Serwisu na rozpoznanie reklamacji, Operator Serwisu zwróci się do Klienta
            o wyjaśnienie wątpliwości lub o udzielenie dodatkowych informacji drogą elektroniczną, jeżeli będzie to
            konieczne do rozpoznania reklamacji przez Operatora Serwisu, wskazując dokładnie takie wątpliwości lub
            wymagane informacje. Jeżeli pomimo tego Klient nie prześle wymaganych danych, Operator Serwisu może
            pozostawić reklamację bez rozpatrzenia.{' '}
         </Typography>
         <Typography>
            11.2. Reklamacja powinna być złożona w terminie 30 dni od zaistnienia reklamowanego zdarzenia. Reklamacje
            nie będą rozpatrywane po upływie wspomnianego 30-dniowego terminu.
         </Typography>
         <Typography>
            11.3. Reklamacje będą rozpatrywane w terminie 30 dni od daty ich otrzymania. Odpowiedź na reklamację
            wysyłana jest drogą elektroniczną na adres podany w zgłoszeniu reklamacyjnym.
         </Typography>
         <Typography>
            11.4. Składając reklamację Klient zgadza się na przetwarzanie danych osobowych w zakresie adresu e-mail, z
            którego została wysłana reklamacja.
         </Typography>
         <Typography variant="h6" fontWeight="bold" textAlign="center">
            12. Postanowienia końcowe
         </Typography>
         <Typography>
            12.1. Operator Serwisu ma prawo do zmiany postanowień Regulaminu poprzez ich zamieszczenie w Serwisie i
            dostarczenie takiej informacji do Klienta na podany adres e-mail. Zmiany wchodzą w życie w terminie
            wskazanym przez Operatora Serwisu, chyba że obowiązujące przepisy prawa stanowią inaczej. Klient powinien
            zapoznać się ze zmianami wprowadzonymi przez Operatora Serwisu.
         </Typography>
         <Typography>
            12.2. Klient, który nie wyraża zgody na zmiany w Regulaminie, nie może korzystać z Konta po upływie terminu,
            o którym mowa w pkt 13.1. Dalsze korzystanie przez Klienta z Serwisu po wejściu w życie zmian w Regulaminie
            jest równoznaczne z akceptacją tych zmian.
         </Typography>
         <Typography>
            12.3. Prawem właściwym dla wszelkich umów pomiędzy Klientem a Operatorem Platformy są odpowiednie przepisy
            prawa polskiego.
         </Typography>
         <Typography>
            12.4. Jeżeli jakiekolwiek postanowienie niniejszego Regulaminu jest nieważne lub nieskuteczne, nie wpływa to
            na ważność pozostałych postanowień. Nieważne lub nieskuteczne postanowienia zostaną zastąpione
            postanowieniami, które w największym stopniu odpowiadają celowi biznesowemu i charakterowi relacji między
            Operatorem Serwisu a Klientem.
         </Typography>
      </Box>
   )
}
